import React, { Component } from 'react';
import { StyledButton } from './Button.style';

export default class Button extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    const { onClick } = this.props;
    onClick(event);
  }

  render() {
    const {
      disableFluid,
      className,
      children,
      styled,
      reverse,
      truncate,
      disabled,
      submit,
      type,
      loading,
    } = this.props;
    const fluid = !disableFluid ? 'fluid' : '';
    const Comp = styled ? StyledButton : 'button';
    const cn = className ? `${className} pure-button ${fluid}` : `pure-button ${fluid}`;

    return (
      <Comp
        type={type || 'button'}
        data-type={submit ? 'submit' : ''}
        disabled={disabled}
        className={cn}
        onClick={this.onClick}
        styled={styled}
        reverse={reverse}
        truncate={truncate}
        submit={submit}
      >
        {children}
      </Comp>
    );
  }
}
